export const LINK_TYPE = {
  ID: 'id',
  URL: 'url',
  SECTION: 'section',
};

export const DROPDOWN_CLASS = {
  STYLE1: 'dropdown-style1',
  STYLE2: 'dropdown-style2',
};

export const CAROUSEL_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
  NONE: 'none',
};

export const CAROUSEL_MODE = {
  CAROUSEL: 'carousel',
  SLIDESHOW: 'slideshow',
};

export const THUMBS_POSITION = {
  COVER: 'cover',
  BOTTOM: 'bottom',
};

export const PAGE_TYPE = {
  ENQUIRY: 'enquiry',
  BROCHURE: 'brochure',
  PREORDERBROCHURE: 'preorderbrochure',
  SHORTLIST: 'shortlist',
  COMPETITION: 'competition',
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  BLOG_ENQUIRY: 'blog_enquiry',
};

export const NULLVALUES = {
  INT: -2147483648,
  DATE: '0001-01-01T00:00:00',
};
